const initalState = {
  isActive:false,
  data:null,
  type:null,
  loading:false
}

export default function reducer(state = initalState,action){
  switch (action.type){
    case 'TOGGLE_OVERLAY':{
      state = {
        ...state,
        isActive:action.payload.isActive,
        data:action.payload.data,
        type:action.payload.type
      }
      break
    }
    case 'COPY_VENUE_PENDING':
    case 'DELETE_VENUE_PENDING':{
      state = {
        ...state,
        loading:true
      }
      break
    }
    case 'COPY_VENUE_FULFILLED':
    case 'DELETE_VENUE_FULFILLED':{
      state = {
        ...state,
        loading:false,
        isActive:false
      }
      break
    }
  }
  return state
}


// WEBPACK FOOTER //
// ./src/store/reducers/overlayReducer.js